import React, { useEffect }  from "react";
import { createStep, useForm } from "@/Components/formik-steps";
import { dateToHumanReadableString } from "../../helpers";
import Preview from "@/Components/steps/Preview";
import InfoPopperElement from "@/Components/InfoPopperElement";
import classNames from "classnames";
import axios from "axios";
import * as yup from "yup";
import { useError } from "@/Components/formik-steps/Error";


function Availability({
    availability,
    available = true,
    showInfoElement = false,
  }) {
    const { values, setFieldValue } = useForm();
  
    const title = dateToHumanReadableString(availability.Date);
  
    const isSelected = values.availability?.Date === availability.Date;
  
    return (
      <div className="inline-flex w-full flex-col gap-2">
        <div
          onClick={() => {
            if (available) {
              setFieldValue("availability", availability);
            }
          }}
          className={classNames(
            "inline-flex items-center gap-5 px-6 py-3 rounded-xl w-full box-border",
            {
              "border-2 border-[#B71922]": isSelected,
              "border border-[#D6D6D6]": !isSelected,
              "bg-[#ccc]": !available,
              "cursor-pointer": available,
              "cursor-not-allowed": !available,
            }
          )}
        >
          <input
            type="radio"
            value={availability.Date}
            checked={isSelected}
            disabled={!available}
            onChange={() => {
              if (available) {
                setFieldValue("availability", availability);
              }
            }}
          />
          <div>
            <p className="text-[#070707] text-lg font-medium leading-[normal] tracking-[0.18px] ">
              {title}
            </p>
          </div>
  
          {showInfoElement && (
            <div className="ml-auto">
              <InfoPopperElement />
            </div>
          )}
        </div>
      </div>
    );
  }

function Planner() {
  const { values } = useForm();

  if (!values.show_availabilities) {
    return null;
  }

  return (
    <div className="relative w-full mb-[24px]">
      {values.availabilities.length > 0 && (
        <>
          <h3 className="text-[#070707] text-2xl font-semibold leading-[normal] tracking-[0.24px] mb-[24px] mt-[36px]">
            Selecteer datum
          </h3>
          <div className="inline-flex flex-col gap-[16px] max-h-[300px] overflow-y-auto w-full">
            {values.availabilities.map((availability, index) => (
              <PlannerTab {...availability} key={index} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}

function PlannerTab(availability) {
  const { values } = useForm();

  if (values.active_activities.length === 0) {
    return null;
  }

  let includesApkActivity = false;
  let includesTyreActivity = false;
  let estimatedDuration = 0;

  for (let i = 0; i < values.active_activities.length; i++) {
    const activity = values.active_activities[i];
    estimatedDuration += activity.Estimated_duration;

    if (activity.Is_apk) {
      includesApkActivity = true;
    }

    if (activity.Is_tyre_change) {
      includesTyreActivity = true;
    }
  }

  if (
    estimatedDuration + availability.Planned_minutes >
    availability.Available_minutes
  ) {
    return <Availability availability={availability} available={false} />;
  }

  if (
    includesApkActivity &&
    availability.Apk_available_number - availability.Apk_reserved_number < 0
  ) {
    return <Availability availability={availability} available={false} />;
  }

  if (
    includesTyreActivity &&
    availability.Tyre_change_available_number -
      availability.Tyre_change_reserved_number <
      0
  ) {
    return <Availability availability={availability} available={false} />;
  }

  return <Availability availability={availability} available={true} />;
}

function AvailabilityStep() {
  const { values, setFieldValue } = useForm();

  const availabilityError = useError("availability");

  useEffect(() => {
    axios
      .get("/wp-json/all-mobile-cars/v1/availability")
      .then(({ data: availabilities }) => {
        setFieldValue("availabilities", availabilities.data);
      });
  }, []);

  return (
      <div className="inline-flex flex-col w-full items-center">
      <h1 className="text-[#070707] font-inter text-[40px] font-bold  text-left w-full leading-[normal] tracking-[0.4px] mb-[36px]">
      {/* <h1 className="mb-[36px] text-[#070707] text-left text-4xl font-bold leading-[normal] tracking-[0.36px]"> */}
        Kies je tijd
      </h1>

          {/* <div className="w-full max-w-[669px]"> */}
          <div className="w-full flex justify-center items-center">
        <Preview />
      </div>

      {availabilityError && (
        <div className="flex items-center gap-1">
          <svg
            className="shrink-0 "
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 0.625C4.825 0.625 0.625 4.825 0.625 10C0.625 15.175 4.825 19.375 10 19.375C15.175 19.375 19.375 15.175 19.375 10C19.375 4.825 15.175 0.625 10 0.625ZM10 15.625C9.3125 15.625 8.75 15.0625 8.75 14.375C8.75 13.6875 9.3125 13.125 10 13.125C10.6875 13.125 11.25 13.6875 11.25 14.375C11.25 15.0625 10.6875 15.625 10 15.625ZM11.4313 5.93125L11.0125 10.9438C10.9688 11.4688 10.5312 11.875 10 11.875C9.46875 11.875 9.03125 11.4688 8.9875 10.9438L8.56875 5.93125C8.5 5.09375 9.15625 4.375 10 4.375C10.8 4.375 11.4375 5.025 11.4375 5.8125C11.4375 5.85 11.4375 5.89375 11.4313 5.93125Z"
              fill="#FE4A49"
            ></path>
          </svg>
          <p className="text-red-700 mb-0 text-[15px]">{availabilityError}</p>
        </div>
      )}

      <Planner />
    </div>
  );
}

export default createStep({
    component: <AvailabilityStep />,
    validation: {
        availability: yup.object().required("Beschikbaarheid is vereist.")
    }
});
